<template>
  <div class="help">
    <button v-if="isOpen"
            class="help__btn">
      <span v-if="title"
            class="help__btn-text">
        {{ title }}
      </span>
      <BaseSvg name="ico-help"/>
    </button>
    <button v-else
            @click.prevent="open"
            class="help__btn">
      <span v-if="title"
            class="help__btn-text">
        {{ title }}
      </span>
      <BaseSvg name="ico-help"/>
    </button>
    <transition name="dropdown">
      <div v-if="isOpen"
           v-click-out.prevent="close"
           :style="{left}"
           class="help__dropdown">
        <div ref="dropdown-content"
             :style="{width, maxWidth, opacity}"
             class="help__dropdown-content">
          <slot>
            {{ value }}
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      value: String,
      width: {
        type: String
      }
    },
    data() {
      return {
        isOpen: false,
        space: 10,
        maxWidth: null,
        left: null,
        opacity: 0
      }
    },
    methods: {
      open() {
        this.isOpen = true

        setTimeout(() => {
          this.setDropdownPositionParams()

        })
      },
      close() {
        this.isOpen = false
        this.maxWidth = null
        this.left = null
        this.opacity = 0
      },
      setDropdownPositionParams() {
        let content = this.$refs['dropdown-content']
        if (!content) return

        let maxWidth = document.documentElement.clientWidth - this.space * 2
        let minLeft = this.space
        let maxRight = document.documentElement.clientWidth - this.space

        const cords = content.getBoundingClientRect()
        // console.log(cords)

        if (cords.width > maxWidth) {
          this.maxWidth = maxWidth
        }

        if (cords.left < minLeft) {
          let dif = Math.round(-(cords.left - minLeft))
          this.left = `${dif}px`
        }

        if (cords.right > maxRight) {
          let dif = Math.round(cords.right - maxRight)
          this.left = `${-dif}px`
        }

        this.opacity = 1
      }
    }
  }
</script>

<style lang="less">

</style>
